import { useSEO } from '../../hooks/useSEO';
import PortfolioHero from './components/PortfolioHero';
import PortfolioGrid from './components/PortfolioGrid';
import PortfolioCTA from './components/PortfolioCTA';

export default function PortfolioPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.bamme-media.de';
  const canonicalUrl = `${siteUrl}/portfolio`;
  const ogImageUrl = 'https://public.readdy.ai/ai/img_res/a95b5862e05e4a8a44fd14aeed8be61e.jpg';

  useSEO({
    title: 'Portfolio - Unsere Projekte | Bamme-Media Webdesign Agentur',
    description: 'Entdecken Sie unsere erfolgreich umgesetzten Projekte in Webdesign, Social Media, Foto & Videographie und Branding. Jedes Projekt ist einzigartig und perfekt auf die Kundenbedürfnisse zugeschnitten.',
    keywords: 'Portfolio, Webdesign Projekte, Social Media Projekte, Foto Videographie, Branding Projekte, Referenzen',
    canonical: canonicalUrl,
    robots: 'index, follow',
    ogTitle: 'Portfolio - Unsere Projekte | Bamme-Media',
    ogDescription: 'Entdecken Sie unsere erfolgreich umgesetzten Projekte in Webdesign, Social Media, Foto & Videographie und Branding.',
    ogImage: ogImageUrl,
    ogImageWidth: '1200',
    ogImageHeight: '630',
    ogImageAlt: 'Bamme-Media Portfolio Showcase',
    ogUrl: canonicalUrl,
    ogType: 'website',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Portfolio - Unsere Projekte | Bamme-Media',
    twitterDescription: 'Entdecken Sie unsere erfolgreich umgesetzten Projekte in Webdesign, Social Media, Foto & Videographie und Branding.',
    twitterImage: ogImageUrl,
    twitterImageAlt: 'Bamme-Media Portfolio Showcase',
    geoPosition: '51.1657;10.4515',
    geoRegion: 'DE-TH',
    geoPlacename: 'Thüringen',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Portfolio - Unsere Projekte',
      description: 'Entdecken Sie unsere erfolgreich umgesetzten Projekte in Webdesign, Social Media, Foto & Videographie und Branding.',
      url: canonicalUrl,
      inLanguage: 'de-DE',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Bamme-Media',
        url: siteUrl
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: siteUrl
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Portfolio',
            item: canonicalUrl
          }
        ]
      }
    }
  });

  return (
    <div className="bg-black min-h-screen">
      <PortfolioHero />
      <PortfolioGrid />
      <PortfolioCTA />
    </div>
  );
}